import {
  CardBody,
  CardFooter,
  CardHeader,
  cn,
  emptyFragment,
  Popover,
} from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import ProportionalImage from '../../../../../components/ProportionalImage';
import { usePortalExperienceContext } from '../../../PortalExperience/UsePortalExperienceContext';
import ExperienceBody from '../../ExperienceBody';
import ExperienceFooter from '../../ExperienceFooter';
import ExperienceHeaderEndIcon from '../../ExperienceHeaderEndIcon';
import ExperienceHeaderLogo from '../../ExperienceHeaderLogo';
import ProgramExperienceCard from '../../ProgramExperienceCard';
import ExperiencePopover from './ExperiencePopover';
import ExperienceVideoState from './ExperienceVideoState';

function ExperienceTile() {
  const experienceEntry = usePortalExperienceContext();
  return experienceEntry
    .map((experience) => (
      <Popover
        className="max-w-[20.625rem] text-black"
        trigger="hover"
        delay={{ open: 1000, close: 0 }}
        returnFocus={false}
        placement="right"
        renderTrigger={(renderTriggerProps) => (
          <ProgramExperienceCard
            ref={renderTriggerProps}
            className={
              'h-full min-h-[14rem] w-[20rem] cursor-pointer bg-white text-gray-800 shadow-tile-preview'
            }
            data-intercom-target="discovery-portal-experience-tile"
          >
            <ExperienceVideoState
              experienceResource={experience}
              className="h-[11.125rem] w-full flex-none rounded-t"
            >
              <div
                className={cn(
                  'box-border flex  h-[11.125rem] w-full  items-center justify-center rounded-t bg-[#e1e1e1] p-2 sm:h-35 sm:w-[15.5rem]',
                )}
              >
                <ProportionalImage
                  href={experience.links.schoolPartner.href}
                  height={38}
                  alt={''}
                />
              </div>
            </ExperienceVideoState>
            <CardHeader
              className={'h-[2.375rem] rounded-t py-1.5'}
              endContent={<ExperienceHeaderEndIcon />}
            >
              <ExperienceHeaderLogo />
            </CardHeader>
            <CardBody data-intercom-target="discovery-portal-experience-tile-body">
              <ExperienceBody />
            </CardBody>
            <CardFooter>
              <ExperienceFooter />
            </CardFooter>
          </ProgramExperienceCard>
        )}
      >
        {({ onClose }) => <ExperiencePopover experience={experience} />}
      </Popover>
    ))
    .getOrElse(emptyFragment);
}

export default observer(ExperienceTile);
